(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/components/fractiongames/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/components/fractiongames/assets/javascripts/prescript.js');

'use strict';

svs.vikinglotto = svs.vikinglotto || {};
svs.vikinglotto.components = svs.vikinglotto.components || {};
svs.vikinglotto.components.fractiongames = svs.vikinglotto.components.fractiongames || {};

 })(window);